import React from 'react';
import ProductPage from '../components/product/ProductPage';
import { infinityBrainConfig } from '../config/products';

const InfinityBrainPage: React.FC = () => {
  return <ProductPage config={infinityBrainConfig} />;
};

export default InfinityBrainPage;

